import { usePathname } from 'next/navigation';

export const useIsDarkVariantPage = () => {
	const pathname = usePathname();
	const darkPages = ['/', '/replace/', '/repair/']; // Add more pages here if needed
	const pageDarkVariant = darkPages.some((page) => page === pathname);

	return pageDarkVariant;
};
